import { render, staticRenderFns } from "./CustomerGoodsFeeForm.vue?vue&type=template&id=68b33f9a&scoped=true"
import script from "./CustomerGoodsFeeForm.vue?vue&type=script&lang=js"
export * from "./CustomerGoodsFeeForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerGoodsFeeForm.vue?vue&type=style&index=0&id=68b33f9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b33f9a",
  null
  
)

export default component.exports